const elemOffers = document.querySelectorAll('.wdgt-OfferCnt');
const vertical = window.TCMS.product;

window.fireOnVisible(elemOffers, async(elemOffer) => {
    await import('./assets/css/offer_default.scss');

    if (vertical === 'mietwagen' || vertical === 'urlaub') {
        await import(`./assets/css/offer_${vertical}.scss`);
    }

    const sliderElement = elemOffer.querySelector('.tcmsSlider');
    const hotelCategoryInfoTextTemplate = elemOffer.querySelector('template.wt-Offer-HotelCategoryInfoText')?.content;

    if (sliderElement) {
        await import('../../assets/frontend/js/tcmsSlider/tcms_base_tcmsSlider.ts').then(({ TcmsSlider }) => {
            new TcmsSlider(sliderElement, {
                offset: 16,
                slidesPerView: 1.2,
                slideMinWidth: 308,
                slideMaxWidth: 309,
                breakpoints: {
                    740: {
                        navigation: true,
                        slidesPerView: 3,
                        spaceBetween: 15
                    },
                    1025: {
                        offset: 0,
                        slidesPerView: 4
                    }
                }
            });
        });
    }

    if (hotelCategoryInfoTextTemplate) {
        await import('../../assets/frontend/js/classes/TcmsModalWindow.js').then((ModalWindow) => {
            ModalWindow = ModalWindow.default;
            const OfferModal = new ModalWindow(null, {
                mainElemClasses: ['wt-OfferModal'],
                mobileSheet: true
            });

            const hotelCategoryInfoTextDefault = hotelCategoryInfoTextTemplate.querySelector('.default').innerText;

            elemOffer.querySelectorAll('.offer-rating-wrapper').forEach((hotelRatingElem) => {
                hotelRatingElem.addEventListener('click', (e) => {
                    const infoTextCategory = e.currentTarget.dataset.modalContentCategory;
                    const infoText = infoTextCategory
                        ? hotelCategoryInfoTextTemplate.querySelector(`.${infoTextCategory}`)?.innerText
                        : hotelCategoryInfoTextDefault;

                    OfferModal.content = `<div>${infoText}</div>`;
                    OfferModal.open();
                });
            });
        });
    }
});
